module.exports = __webpack_public_path__ + "img/img_app_bnr_03_feature1.96383dba.png";